import React, { useEffect, useState } from "react";
import Modal from "react-modal"
import error_img from "../../assets/images/modal_question.svg";
import CallServer from '../../api/api'
import Spinner from 'react-bootstrap/Spinner';

import { NotificationManager } from 'react-notifications';


export default function EditorModal(props) {
    const [textData, setTextData] = useState({
        blocked_key: false
    })
    const [isLoading, setIsLoading] = useState(false)

    let userPermissions = null
    if(localStorage.getItem("i18n_user_permissions") !== "undefined"){
        userPermissions = JSON.parse(localStorage.getItem("i18n_user_permissions"));
    }
    
    const generateId = () => {
        const newValue = `DYNAMIC_TEXTS.GENERIC.${uuidv4()}`
        setTextData({
            ...textData,
            key: newValue
        });
    }

    const handleTranslate = async () => {
        setIsLoading(true)
        const response = await CallServer.translate_text({
            "translation_language_source": "it",
            "translation_languages_target": ["en", "es"],
            "text": textData?.texts?.it
        })
        if(response.success){
            setTextData({
                ...textData,
                texts:{
                    ...textData.texts,
                    en: response.data?.find(t=> t.language === "en")?.value || '',
                    es: response.data?.find(t=> t.language === "es")?.value || ''
                }
            });
        } else {
            NotificationManager.error('Error while translating', 'Error')
        }
        setIsLoading(false)
    }

    const handleSaveText = async (to_review = false) => {
        let field_id = textData.key
        if(!field_id){
            const newValue = `DYNAMIC_TEXTS.GENERIC.${uuidv4()}`
            field_id = newValue
        }
        if(textData?.texts?.it && textData?.texts?.en && textData?.texts?.es){
            const data = {
                "key": field_id,
                "texts": {
                    "it": textData?.texts?.it || '',
                    "en": textData?.texts?.en || '',
                    "es": textData?.texts?.es || ''
                },
                "to_review": to_review
            };
            console.log(data);
            
            const response = await CallServer.upsert_text(data)
            if(response.success){
                setTextData({
                    ...textData,
                    blocked_key: true
                })
                NotificationManager.success('Text saved correctly', 'Ok')
                onCloseModal()
            } else {
                NotificationManager.error('Error while editing translations', 'Error')
            }
        } else {
            NotificationManager.error('The string must have a valid translation in all languages', 'Error')
        }    
    }

    const onCloseModal = () => {
        props.onRequestClose();
    }

    const loadTextData = async() => {
        if(props.textKey){
            const response = await CallServer.get_text(["it","en","es"], [props.textKey])
            if(response.success){
                setTextData({
                    key: props.textKey,
                    texts: {
                        it: response?.data[props.textKey]?.it,
                        en: response?.data[props.textKey]?.en,
                        es: response?.data[props.textKey]?.es
                    },
                    blocked_key: true
                })
            } else {
                NotificationManager.error('Unable to load text data', 'Oops');
            }
        } else {
            setTextData({
                key: "",
                texts: {
                    it: "",
                    en: "",
                    es: ""
                }
            })
        }
        
    }

    const handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        
        setTextData({
            ...textData,
            [name]: value
        });
    }

    const handleChangeText = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        
        setTextData({
            ...textData,
            texts: {
                ...textData.texts,
                [name]: value
            }
        });
    }

    const uuidv4 = () => {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
        );
    }
    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 10010
        },
        content: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: "translate(-50%, -50%)",
            width: '100%',
            maxWidth: "700px",
            border: '0',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: "24px",
            outline: 'none',
            padding: '0'
        }
    }

    useEffect(() => {
        loadTextData()
        setIsLoading(false)
    }, [props])

    return (
        <>
            <Modal
                closeTimeoutMS={300}
                isOpen={props.show}
                contentLabel="modal"
                onRequestClose={onCloseModal}
                className="center_modal"
                overlayClassName="bottom_modal_overlay"
                ariaHideApp={false}
                style={style}
            >
                <div className="modal-content">
                    <div className='d-flex justify-content-start mb-3'>
                        <button onClick={onCloseModal}>
                            Exit
                        </button>
                    </div>
                    <div className='d-flex align-items-center'>
                        <div className="input-group" >
                            <label>Key ID</label>
                            <input 
                                className={`i18n_input`}
                                name='key'
                                value={textData?.key || ''}
                                onChange={handleChange}
                                disabled={textData.blocked_key}
                            />
                        </div>
                        {
                            !textData.blocked_key &&
                                <button onClick={generateId}>
                                    Generate ID
                                </button>
                        }
                    </div>
                    
                    <div className='d-flex align-items-center'>
                        <div className="input-group" >
                            <label>IT Text</label>
                            <textarea 
                                className={`i18n_input`}
                                name='it'
                                value={textData?.texts?.it || ''}
                                onChange={handleChangeText}
                            />
                        </div>
                        <button onClick={handleTranslate}>
                            Translate
                        </button>
                    </div>
                    
                    <div className="input-group" >
                        <label>EN Text</label>
                        <textarea 
                            className={`i18n_input`}
                            name='en'
                            value={textData?.texts?.en || ''}
                            onChange={handleChangeText}
                        />
                    </div>
                    
                    <div className="input-group" >
                        <label>ES Text</label>
                        <textarea 
                            className={`i18n_input`}
                            name='es'
                            value={textData?.texts?.es || ''}
                            onChange={handleChangeText}
                        />
                    </div>
                    {isLoading &&
                        <Spinner animation="border" role="status">
                        </Spinner>
                    }
                    {userPermissions?.write &&
                        <div className='d-flex justify-content-end'>
                            <button className="bg-warning me-2" onClick={()=>handleSaveText(true)}>
                                Save Text to review
                            </button>
                            <button className="bg-success" onClick={()=>handleSaveText(false)}>
                                Save Text and approve
                            </button>
                        </div>
                    }
                </div>
            </Modal>
        </>
    );
}